import type { IStandardErrorResponse } from 'src/api/common';
import { useMutation, useQueryClient } from 'react-query';

import type { IPlaybookV2 } from 'src/services/api/playbooks/types';
import { useNotifications } from 'src/notifications';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { playbooksPath } from 'src/services/api/playbooks/path';
import { getApiErrorMessage } from 'src/services/api/utils';

type ICreatePlaybookV2Request = {
    playbook: IPlaybookV2;
}

export const useCreatePlaybookV2 = () => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<IPlaybookV2, IStandardErrorResponse, ICreatePlaybookV2Request>(
        async (payload) => {
            const res = await apiClient(playbooksPath, {
                method: 'post',
                json: payload
            }).json<{ playbook: IPlaybookV2 }>();

            return res.playbook;
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries(queryKeys.playbooksV2);
                queryClient.invalidateQueries(queryKeys.achievements);
                addNotification('Playbook created', 'success');
            },
            onError: (error) => {
                const errorMessage = getApiErrorMessage(error) || 'Failed to create playbook';
                addNotification(errorMessage, 'error');
            }
        }
    );
};
